var utils = require('lib/utils');

class LoadService {
  static load(files) {
    const fileEntries = Object.entries(files);
    if (fileEntries.length === 1) {
      const [key, path] = fileEntries[0];
      return LoadService.getRequestFromPath(path, key);
    }
    const promises = [];
    fileEntries.forEach(([key, path]) => {
      const request = LoadService.getRequestFromPath(path, key);
      promises.push(request);
    });
    return Promise.all(promises).then(resolvedPromises => {
      let obj = {};
      resolvedPromises.forEach(data => {
        Object.keys(data).forEach(key => {
          obj[key] = data[key];
        });
      });
      return obj;
    });
  }
  static getRequestFromPath(path, key) {
    const url = utils.coursePath(path);
    return fetch(url)
      .then(v => v.json())
      .then(data => (key ? { [key]: data } : data))
      .catch(err => {
        const sanitizedError = encodeURI(err);
        console.error(`Load Service failed at fetch: ${sanitizedError}`);
        return { [key]: undefined };
      });
  }
}

export default LoadService;
